import {
    Button,
    Dialog,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from "frontend-components";
import { useTranslation } from "react-i18next";

export function ConfirmDiscardDialog({
    open,
    onOpenChange,
    onConfirm,
}: {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    onConfirm: () => void;
}) {
    const { t } = useTranslation();
    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="bg-compendia-card max-w-md text-compendia-foreground">
                <DialogHeader>
                    <DialogTitle>{t("common.discardChanges")}</DialogTitle>
                </DialogHeader>
                <p className="text-body text-compendia-foreground">
                    {t("common.confirmDiscardChanges")}
                </p>
                <DialogFooter>
                    <div className="flex justify-end gap-2 w-full">
                        <Button variant="outline" type="button" onClick={() => onOpenChange(false)}>
                            {t("common.keepEditing")}
                        </Button>
                        <Button
                            variant="fill"
                            type="button"
                            className="bg-chameleon-pink border-chameleon-pink"
                            onClick={() => {
                                onConfirm();
                                onOpenChange(false);
                            }}
                        >
                            {t("common.discard")}
                        </Button>
                    </div>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
